import React, { useState, useEffect, useContext } from "react";
import ClassNames from "classnames";
import * as s from "./s.module.scss";
import { animated, useTrail } from "react-spring";
import Portal from "../../Portal";
import Globe from "../../Icons/_LineStyle/Globe";
import content from "../../../../content/global";
import { useBodyClass } from "../../_customHooks";
import { UserIPLocation } from "../../Layout";
import LanguageSwitch from "../../LocalizedLink/LanguageSwitch";

const MobileNav = ({
  data,
  onGetInTouchClick,
  currentPath,
  locale,
  setModalLanguageIsOpen,
}) => {
  const [menuState, setMenuState] = useState("inactive");
  const [languageMenu, setLanguageMenu] = useState(
    content.language_sub_menus[locale]
  );

  const toggleMenu = () => {
    switch (menuState) {
      case "inactive":
        setMenuState("active");
        break;
      case "active":
      case "subMenuActive":
        setMenuState("inactive");
        break;
      default:
        setMenuState("inactive");
        break;
    }
  };

  const config = { mass: 1, tension: 2000, friction: 100 };

  const transitions = useTrail(null, {
    config,
    opacity: menuState === "subMenuActive" || menuState === "active" ? 1 : 0,
    transformOverlay:
      menuState === "subMenuActive" || menuState === "active"
        ? "translate3d(0%, 0%, 0)"
        : "translate3d(0%, -100%, 0)",
    transform:
      menuState === "subMenuActive"
        ? "translate3d(-100%, 0%, 0)"
        : menuState === "active"
        ? "translate3d(0%, 0%, 0)"
        : "translate3d(0%, -100%, 0)",
    from: { transform: "translate3d(0%, -100%, 0)" },
  });

  useBodyClass(
    menuState === "active" || menuState === "subMenuActive",
    s.mobileNavOpen
  );

  const tdcxCN = process.env.GATSBY_BUILD_SITE === "china";
  const { userIPLocationCode } = useContext(UserIPLocation);

  return (
    <>
      {!tdcxCN && (
        <div>
          <button
            className={ClassNames(s.mobileMenuGlobe, {
              [s.isActive]:
                menuState === "active" || menuState === "subMenuActive",
            })}
            type="button"
            onClick={toggleMenu}
          >
            <Globe />
          </button>
        </div>
      )}
      <Portal>
        <>
          {transitions.map(
            ({ transform, transformOverlay, opacity, ...props }, index) => (
              <div key={index}>
                <animated.div
                  style={{
                    ...props,
                    position: "fixed",
                    top: 56,
                    left: 0,
                    opacity: opacity.interpolate((x) => `${x}`),
                    transform: transformOverlay.interpolate((x) => `${x}`),
                  }}
                  className={s.mobileMenuOverlay}
                />
                <animated.div
                  style={{
                    ...props,
                    transform: transform.interpolate((x) => `${x}`),
                  }}
                  className={s.mobileMenuWrapper}
                >
                  <div className={s.headerMobileMenu}>
                    {languageMenu &&
                      languageMenu.map((list, i) => (
                        <LanguageSwitch
                          ipCode={userIPLocationCode}
                          key={i}
                          to={list.link}
                          type={list.type}
                          className={s.headerMobileMenuItem}
                          activeClassName={s.isActive}
                        >
                          <span>{list.title}</span>
                        </LanguageSwitch>
                      ))}
                  </div>
                </animated.div>
              </div>
            )
          )}
        </>
      </Portal>
    </>
  );
};

export default MobileNav;
